import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'course-columns';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id, is_get_all_states = 0, is_get_refund_state = 0) {
  return get({
    url: `${url}/${id}`,
    data: {
      is_get_all_states,
      is_get_refund_state,
    },
  });
}

export function getQrCode(id) {
  return patch({
    url: `${url}/${id}/qr-codes`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}

// 取消预约
export function cancelReserve(id, data) {
  return del({
    url: `${url}/${id}/reservations`,
    data,
  });
}
